<div class="location-autocomplete">

    <div class="input-wrapper">

        <input #locationInput type="text" class="location-input" [value]="value" [placeholder]="placeholder"
            autocomplete="off" (input)="onInput($event)" (focus)="onFocus()" (blur)="onBlur()"
            (keydown)="onKeyDown($event)" />

        <button mdbRipple class="icon-right btn btn-white btn-floating bg-white current-location-btn" type="button"
            mdbTooltip="Use current location" (mousedown)="$event.preventDefault()"
            (click)="handleSelectCurrentLocationClick()">
            <i class="fa-solid fa-location-crosshairs text-primary fa-lg"></i>
        </button>
        <span *ngIf="isLoading" class="loading-spinner">
            ...
        </span>

    </div>

    <div class="suggestions" *ngIf="
            isFocused &&
            suggestions.length > 0
        ">

        <div *ngFor="
                let suggestion of suggestions;
                let i = index
            " class="suggestion" [class.active]="
                i === selectedSuggestionIndex
            " (mousedown)="$event.preventDefault()" (click)="selectSuggestion(suggestion)">

            <div class="suggestion-main">

                {{
                suggestion.placePrediction
                .structuredFormat
                ?.mainText
                ?.text
                ||
                suggestion.placePrediction
                .text
                .text
                }}

            </div>

            <div class="suggestion-secondary" *ngIf="
                    suggestion.placePrediction
                        .structuredFormat
                        ?.secondaryText
                        ?.text
                ">

                {{
                suggestion.placePrediction
                .structuredFormat
                .secondaryText
                .text
                }}

            </div>

        </div>

    </div>

</div>